import {  Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { MainContentComponent } from './main-content/main-content.component';
import { LoginComponent } from './login/login.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { AllQueryTableComponent } from './all-query-table/all-query-table.component';
export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    canActivate: [MsalGuard],
  },
  {
    path:  'view-query',
    component: AllQueryTableComponent,
    data: { queryType: 'filter' },
    canActivate: [MsalGuard],
  },
  {
    path:  'manage-template',
    component: AllQueryTableComponent,
    data: { queryType: 'template' },
    canActivate: [MsalGuard],
  },
  {
    path: 'auth',
    component: MsalRedirectComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'filter-criteria/:id',
    component: MainContentComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    component: LandingPageComponent,
    canActivate: [MsalGuard],
  },
];
